import Modal from '@/components/Modal/Modal.vue';
import SideModal from '@/components/SideModal/SideModal.vue';

import StartMovingModal from '@/componentsV2/templates/Modals/StartMovingModal/StartMovingModal.vue';
import SuccessModal from '@/components/organisms/SuccessModal/SuccessModal.vue';
import ActivateFeatureWidgetModal from '@/components/organisms/ActivateFeatureWidgetModal/ActivateFeatureWidgetModal.vue';
import DeactivationReviewModalV2 from '@/componentsV2/organisms/DeactivationReviewModal/DeactivationReviewModal.vue';
import DeactivationReviewModal from '@/components/organisms/DeactivationReviewModal/DeactivationReviewModal.vue';
import SellCoinsRatioAdjustModal from '@/components/organisms/SellCoinsRatioAdjustModal/SellCoinsRatioAdjustModal.vue';
import SellCoinsCampaignStatusManagementModal from '@/views/SellCoins/Modals/CampaignStatusManagement.vue';
import SellCoinsCampaignCreatedModal from '@/views/SellCoins/Modals/CampaignCreated.vue';
import FeedbackModal from '@/components/organisms/FeedbackModal/FeedbackModal.vue';
import VideoTutorialModal from '@/componentsV2/templates/Modals/VideoTutorialModal/VideoTutorialModal.vue';
import CustomerInactivityModal from '@/componentsV2/templates/Modals/CustomerInactivityModal/CustomerInactivityModal.vue';
import WhatIsNewModal from '@/components/organisms/WhatIsNewModal/WhatIsNewModal.vue';
import OnlineInStoreModal from '@/components/organisms/OnlineInStoreModal/OnlineInStoreModal.vue';
import ToggleRewardsModal from '@/components/organisms/ToggleRewardsModal/ToggleRewardsModal.vue';
import DisableEmail from '@/views/ActivationEmails/Modals/DisableEmail.vue';
import EnableEmail from '@/views/ActivationEmails/Modals/EnableEmail.vue';
import RewardsProgramModal from '@/componentsV2/templates/Modals/RewardsProgramModal/RewardsProgramModal.vue';
import StripeRedirect from '@/views/SellCoins/Modals/StripeRedirect.vue';
import StripeDetailsPendingModal from '@/views/SellCoins/Modals/StripeDetailsPendingModal.vue';
import StripeUnlockWithdrawModal from '@/views/SellCoins/Modals/StripeUnlockWithdrawModal.vue';
import WithdrawSellCoins from '@/views/SellCoins/Modals/WithdrawSellCoins.vue';
import PayoutsHistory from '@/views/SellCoins/Modals/PayoutsHistory.vue';
import DisableSellCoins from '@/views/SellCoins/Modals/DisableSellCoins.vue';
import ActiveSellCoins from '@/views/SellCoins/Modals/ActiveSellCoins.vue';
import EnableSellCoins from '@/views/SellCoins/Modals/EnableSellCoins.vue';
import DisableCampaign from '@/views/MarketingCenter/CustomerImport/Modals/DisableCampaign.vue';
import EnableCampaign from '@/views/MarketingCenter/CustomerImport/Modals/EnableCampaign.vue';
import RestoreWidget from '@/views/Settings/Apps/Modals/Restore.vue';
import SocialRewardsModal from '@/componentsV2/templates/Modals/SocialRewardsModal/SocialRewardsModal.vue';
import SendTestEmailModal from '@/componentsV2/templates/Modals/SendTestEmailModal/SendTestEmailModal.vue';
import ReferralFeedbackModal from '@/components/organisms/Referral/Modals/ReferralFeedbackModal.vue';
import SendAnOfferModal from '@/componentsV2/templates/Modals/SendAnOffer/SendAnOffer.vue';
import AwardCoinsModal from '@/componentsV2/templates/Modals/AwardCoins/AwardCoins.vue';
import DiscardChanges from '@/views/Settings/Apps/Modals/DiscardChanges.vue';
import CustomerImportModal from '@/componentsV2/templates/Modals/CustomerImportModal/CustomerImportModal.vue';
import {
  LearnMoreModal,
  CampaignFeedbackModal,
  NewOnboardingSuccessModal,
  CoinsInstructionsModal,
  CampaignLocationsModal,
  CampaignActivationModal,
  CampaignDeadlineEditModal,
  CampaignCustomerLimitEditModal
} from '@/components/organisms/OfferFreeCoins/Modals';
import ShareCampaignModal from '@/components/ShareCampaignModal/ShareCampaignModal.vue';
import OtherCountryModal from '@/components/organisms/Signup/OtherCountryModal.vue';
import NewCountryNotifyModal from '@/componentsV2/templates/Modals/NewCountryNotifyModal/NewCountryNotifyModal.vue';
import NewProviderNotifyModal from '@/componentsV2/templates/Modals/NewProviderNotifyModal/NewProviderNotifyModal.vue';
import RevokeOwnershipModal from '@/views/Admin/BusinessOwnership/ConfirmModal/ConfirmModal.vue';
import SendEventConfirmationModal from '@/views/Admin/OnlineTransactions/SendEventConfirmationModal.vue';
import TransferOwnershipModal from '@/components/organisms/TransferOwnershipModal/TransferOwnershipModal.vue';
import MarketingCenterConfirmModal from '@/components/organisms/MarketingCenter/ConfirmModal/ConfirmModal.vue';
import MarketingCenterDeleteModal from '@/components/organisms/MarketingCenter/DeleteModal/DeleteModal.vue';
import MarketingCenterShareModal from '@/components/organisms/MarketingCenter/ShareModal/ShareModal.vue';
import MarketingCenterDownloadModal from '@/components/organisms/MarketingCenter/DownloadModal/DownloadModal.vue';
import OnlineProviderModal from '@/components/OnlineProviderModal/OnlineProviderModal.vue';
import LostAccessModal from '@/components/LostAccessModal/LostAccessModal.vue';
import TransactionActionConfirmationModal from '@/views/Admin/OnlineTransactions/TransactionActionConfirmationModal.vue';
import InvitationDifferentAccountModal from '@/componentsV2/templates/Modals/InvitationDifferentAccountModal/InvitationDifferentAccountModal.vue';
import InviteModal from '@/components/InviteModal/InviteModal.vue';
import CropModal from '@/components/CropModal/CropModal.vue';
import ArchiveOfferModal from '@/componentsV2/templates/Modals/ArchiveOfferModal/ArchiveOfferModal.vue';
import DeleteLocationModal from '@/componentsV2/templates/Modals/DeleteLocationModal/DeleteLocationModal.vue';
import LocationFormModal from '@/componentsV2/templates/Modals/LocationFormModal/LocationFormModal.vue';
import BillingLocationUpdatedModal from '@/componentsV2/templates/Modals/BillingLocationUpdatedModal/BillingLocationUpdatedModal.vue';
import CoinNetworkDeactivationModal from '@/componentsV2/templates/Modals/CoinNetworkDeactivationModal/CoinNetworkDeactivationModal.vue';
import CoinNetworkReactivationModal from '@/componentsV2/templates/Modals/CoinNetworkReactivationModal/CoinNetworkReactivationModal.vue';
import CoinNetworkAcceptanceModal from '@/componentsV2/templates/Modals/CoinNetworkAcceptanceModal/CoinNetworkAcceptanceModal.vue';
import CoinNetworkWelcomeModal from '@/componentsV2/templates/Modals/CoinNetworkWelcomeModal/CoinNetworkWelcomeModal.vue';
import CoinNetworkNewsModal from '@/componentsV2/templates/Modals/CoinNetworkNewsModal/CoinNetworkNewsModal.vue';
import CoinNetworkReturnOnlineModal from '@/componentsV2/templates/Modals/CoinNetworkReturnOnlineModal/CoinNetworkReturnOnlineModal.vue';
import BillingLocationBenefitsModal from '@/componentsV2/templates/Modals/BillingLocationBenefitsModal/BillingLocationBenefitsModal.vue';

import LocationsGroupedByCityModal from '@/componentsV2/templates/Modals/LocationsGroupedByCityModal/LocationsGroupedByCityModal.vue';
import BusinessMenuModal from '@/componentsV2/molecules/BusinessMenu/BusinessMenuModal.vue';
import TwismWalletConfirmModal from '@/views/Admin/TwismWallet/TwismWalletConfirmModal.vue';
import CoinStoreDealConfirmModal from '@/views/Admin/CoinStore/CoinStoreDealConfirmModal.vue';
import CoinStoreConfirmModal from '@/views/Admin/CoinStore/CoinStoreConfirmModal.vue';
import ConfirmationModal from '../Modals/ConfirmationModal/ConfirmationModal.vue';
import PreviewAppBusiness from '@/componentsV2/templates/Modals/PreviewAppBusiness/PreviewAppBusiness.vue';
import EditAIOffer from '@/componentsV2/templates/Modals/EditAIOfferModal/EditAIOfferModal.vue';
import StopFlowModal from '@/componentsV2/templates/Modals/StopFlowModal/StopFlowModal.vue';
import ScheduleOnboardingModal from '@/componentsV2/templates/Modals/ScheduleOnboardingModal/ScheduleOnboardingModal.vue';

export const modalComponents = {
  Modal,
  SideModal,

  StartMovingModal,
  SuccessModal,
  ActivateFeatureWidgetModal,
  SellCoinsRatioAdjustModal,
  DeactivationReviewModalV2,
  DeactivationReviewModal,
  SellCoinsCampaignStatusManagementModal,
  SellCoinsCampaignCreatedModal,
  FeedbackModal,
  VideoTutorialModal,
  CustomerInactivityModal,
  WhatIsNewModal,
  OnlineInStoreModal,
  ToggleRewardsModal,
  DisableEmail,
  EnableEmail,
  RewardsProgramModal,
  StripeRedirect,
  StripeDetailsPendingModal,
  StripeUnlockWithdrawModal,
  WithdrawSellCoins,
  PayoutsHistory,
  DisableSellCoins,
  ActiveSellCoins,
  EnableSellCoins,
  DisableCampaign,
  EnableCampaign,
  RestoreWidget,
  SocialRewardsModal,
  SendTestEmailModal,
  ReferralFeedbackModal,
  SendAnOfferModal,
  AwardCoinsModal,
  DiscardChanges,
  CustomerImportModal,
  LearnMoreModal,
  CampaignFeedbackModal,
  NewOnboardingSuccessModal,
  CoinsInstructionsModal,
  CampaignLocationsModal,
  CampaignActivationModal,
  CampaignDeadlineEditModal,
  CampaignCustomerLimitEditModal,
  ShareCampaignModal,
  OtherCountryModal,
  NewCountryNotifyModal,
  NewProviderNotifyModal,
  RevokeOwnershipModal,
  TransferOwnershipModal,
  MarketingCenterConfirmModal,
  MarketingCenterDeleteModal,
  MarketingCenterShareModal,
  MarketingCenterDownloadModal,
  OnlineProviderModal,
  LostAccessModal,
  TransactionActionConfirmationModal,
  InvitationDifferentAccountModal,
  InviteModal,
  CropModal,
  ArchiveOfferModal,
  LocationsGroupedByCityModal,
  BusinessMenuModal,
  LocationFormModal,
  DeleteLocationModal,
  TwismWalletConfirmModal,
  CoinStoreDealConfirmModal,
  CoinStoreConfirmModal,
  SendEventConfirmationModal,
  BillingLocationUpdatedModal,
  BillingLocationBenefitsModal,
  CoinNetworkDeactivationModal,
  CoinNetworkReactivationModal,
  CoinNetworkAcceptanceModal,
  CoinNetworkWelcomeModal,
  CoinNetworkNewsModal,
  CoinNetworkReturnOnlineModal,
  ConfirmationModal,
  PreviewAppBusiness,
  StopFlowModal,
  EditAIOffer,
  ScheduleOnboardingModal
};

export const modalMapper = {
  startMovingModal: 'StartMovingModal',
  successModal: 'SuccessModal',
  activateFeatureWidgetModal: 'ActivateFeatureWidgetModal',
  sellCoinsRatioAdjustModal: 'SellCoinsRatioAdjustModal',
  deactivationReviewModalV2: 'DeactivationReviewModalV2',
  deactivationReviewModal: 'DeactivationReviewModal',
  SellCoinsCampaignStatusManagementModal:
    'SellCoinsCampaignStatusManagementModal',
  SellCoinsCampaignCreatedModal: 'SellCoinsCampaignCreatedModal',
  feedbackModal: 'FeedbackModal',
  videoTutorialModal: 'VideoTutorialModal',
  customerInactivityModal: 'CustomerInactivityModal',
  whatIsNewModal: 'WhatIsNewModal',
  onlineInStoreModal: 'OnlineInStoreModal',
  toggleRewardsModal: 'ToggleRewardsModal',
  disableEmail: 'DisableEmail',
  enableEmail: 'EnableEmail',
  rewardsProgramModal: 'RewardsProgramModal',
  stripeRedirect: 'StripeRedirect',
  stripeDetailsPendingModal: 'StripeDetailsPendingModal',
  stripeUnlockWithdrawModal: 'StripeUnlockWithdrawModal',
  withdrawSellCoins: 'WithdrawSellCoins',
  payoutsHistory: 'PayoutsHistory',
  disableSellCoins: 'DisableSellCoins',
  activeSellCoins: 'ActiveSellCoins',
  enableSellCoins: 'EnableSellCoins',
  disableCampaign: 'DisableCampaign',
  enableCampaign: 'EnableCampaign',
  restoreWidget: 'RestoreWidget',
  socialRewardsModal: 'SocialRewardsModal',
  sendTestEmailModal: 'SendTestEmailModal',
  referralCreationFeedback: 'ReferralFeedbackModal',
  sendAnOfferModal: 'SendAnOfferModal',
  awardCoinsModal: 'AwardCoinsModal',
  discardChanges: 'DiscardChanges',
  customerImportModal: 'CustomerImportModal',
  newOnboardingSuccessModal: 'NewOnboardingSuccessModal',
  campaignShareModal: 'ShareCampaignModal',
  offerFreeCoinsCampaignCreationFeedback: 'CampaignFeedbackModal',
  offerFreeCoinsCustomerLimitEditModal: 'CampaignCustomerLimitEditModal',
  offerFreeCoinsDeadlineEditModal: 'CampaignDeadlineEditModal',
  offerFreeCoinsConfirmModal: 'CampaignActivationModal',
  offerFreeCoinsLocationsModal: 'CampaignLocationsModal',
  offerFreeCoinsLearnMoreModal: 'LearnMoreModal',
  offerFreeCoinsInstructionsModal: 'CoinsInstructionsModal',
  otherCountryModal: 'OtherCountryModal',
  newCountryNotifyModal: 'NewCountryNotifyModal',
  newProviderNotifyModal: 'NewProviderNotifyModal',
  revokeOwnershipModal: 'RevokeOwnershipModal',
  transferOwnershipModal: 'TransferOwnershipModal',
  marketingCenterConfirmModal: 'MarketingCenterConfirmModal',
  marketingCenterDeleteModal: 'MarketingCenterDeleteModal',
  marketingCenterShareModal: 'MarketingCenterShareModal',
  marketingCenterDownloadModal: 'MarketingCenterDownloadModal',
  onlineProviderModal: 'OnlineProviderModal',
  LostAccessModal: 'LostAccessModal',
  transactionActionConfirmationModal: 'TransactionActionConfirmationModal',
  invitationDifferentAccountModal: 'InvitationDifferentAccountModal',
  inviteModal: 'InviteModal',
  archiveOfferModal: 'ArchiveOfferModal',
  locationsGroupedByCityModal: 'LocationsGroupedByCityModal',
  businessMenuModal: 'BusinessMenuModal',
  locationFormModal: 'LocationFormModal',
  deleteLocationModal: 'DeleteLocationModal',
  twismWalletConfirmModal: 'TwismWalletConfirmModal',
  coinStoreDealConfirmModal: 'CoinStoreDealConfirmModal',
  coinStoreConfirmModal: 'CoinStoreConfirmModal',
  sendEventConfirmationModal: 'SendEventConfirmationModal',
  billingLocationUpdatedModal: 'BillingLocationUpdatedModal',
  coinNetworkDeactivationModal: 'CoinNetworkDeactivationModal',
  coinNetworkReactivationModal: 'CoinNetworkReactivationModal',
  coinNetworkAcceptanceModal: 'CoinNetworkAcceptanceModal',
  coinNetworkWelcomeModal: 'CoinNetworkWelcomeModal',
  coinNetworkNewsModal: 'CoinNetworkNewsModal',
  coinNetworkReturnOnlineModal: 'CoinNetworkReturnOnlineModal',
  billingLocationBenefitsModal: 'BillingLocationBenefitsModal',
  confirmationModal: 'ConfirmationModal',
  previewAppBusiness: 'PreviewAppBusiness',
  cropModal: 'CropModal',
  stopFlowModal: 'StopFlowModal',
  editAIOffer: 'EditAIOffer',
  scheduleOnboardingModal: 'ScheduleOnboardingModal'
};
